import React, { useEffect, useState } from "react"
import moment from "moment"
import "moment/locale/ja"

import ajax from "../../common/components/ajax.jsx"
import Constants from "../../common/components/constants.jsx"

import TopicsRow from "./topics-row"
import TopicForm from "./topic-form"

import "../../sass/topics.scss"
import { isFullScreenCategory } from "./Utils"
import CreateIcon from "@mui/icons-material/Create"
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material"
import ContentHeader from "./content-header.jsx"
import { useParams } from "react-router"

export function Topics(props) {
  let { id } = useParams()

  console.log("Topics", props)
  console.log("id", id)
  const currentCategoryId = id ? parseInt(id, 10) : -1

  console.log("currentCategoryId", currentCategoryId)
  const [auth, setAuth] = useState(props.auth)

  const [isLoading, setisLoading] = useState(true)
  const [items, setItems] = useState(props.items)

  const [createAuthorized, setCreateAuthorized] = useState(false)
  const [editAuthorized, setEditAuthorized] = useState(false)
  const [deleteAuthorized, setDeleteAuthorized] = useState(false)
  const [patrolAuthorized, setPatrolAuthorized] = useState(false)

  const [categoryId, setCategoryId] = useState("")
  const [categories, setCategories] = useState(props.categories)
  const [categoryName, setCategoryName] = useState("")

  const [createModalIsOpen, setCreateModalIsOpen] = useState(false)
  const [editModalIsOpen, setEditModalIsOpen] = useState(false)
  const [patrolModalIsOpen, setPatrolModalIsOpen] = useState(false)
  const [loadModalIsOpen, setLoadModalIsOpen] = useState(false)
  const [deleteModalIsOpen, setDeleteModalIsOpen] = useState(false)
  const [alertItems, setAlertItems] = useState({
    alertModalIsOpen: false,
    alertTitle: "",
    alertBody: "",
  })

  const [newTopic, setNewTopic] = useState({
    NEW_CATEGORY_ID: "",
    NEW_TOPIC_AVAILABLE_FROM: moment(),
    NEW_TOPIC_AVAILABLE_TO: moment().add(1, "weeks"),
    NEW_TOPIC_TITLE: "",
    NEW_TOPIC_BODY: "",
    NEW_TOPIC_AUTHOR_NAME: "",
    NEW_MEDIAS: [],
    NEW_PATROLLED: "ACCEPTED",
  })

  const [editTopic, setEditTopic] = useState({
    EDIT_TOPIC_ID: 0,
    EDIT_CATEGORY_ID: "",
    EDIT_TOPIC_AVAILABLE_FROM: props.EDIT_TOPIC_AVAILABLE_FROM,
    EDIT_TOPIC_AVAILABLE_TO: props.EDIT_TOPIC_AVAILABLE_TO,
    EDIT_TOPIC_TITLE: props.EDIT_TOPIC_TITLE,
    EDIT_TOPIC_BODY: props.EDIT_TOPIC_BODY,
    EDIT_TOPIC_CREATED: props.EDIT_TOPIC_CREATED,
    EDIT_TOPIC_AUTHOR_NAME: props.EDIT_TOPIC_AUTHOR_NAME,
    EDIT_MEDIAS: props.EDIT_MEDIAS,
    EDIT_TOPIC_SORT_NO: props.EDIT_TOPIC_SORT_NO,
    EDIT_PATROLLED: props.EDIT_PATROLLED,
  })

  const [patrolTopic, setPatrolTopic] = useState({
    PATROL_TOPIC_ID: 0,
    PATROL_CATEGORY_ID: "",
    PATROL_TOPIC_AVAILABLE_FROM: props.PATROL_TOPIC_AVAILABLE_FROM,
    PATROL_TOPIC_AVAILABLE_TO: props.PATROL_TOPIC_AVAILABLE_TO,
    PATROL_TOPIC_TITLE: props.PATROL_TOPIC_TITLE,
    PATROL_TOPIC_BODY: props.PATROL_TOPIC_BODY,
    PATROL_TOPIC_CREATED: props.PATROL_TOPIC_CREATED,
    PATROL_TOPIC_AUTHOR_NAME: props.PATROL_TOPIC_AUTHOR_NAME,
    PATROL_MEDIAS: props.PATROL_MEDIAS,
    PATROL_TOPIC_SORT_NO: props.PATROL_TOPIC_SORT_NO,
    PATROL_PATROLLED: props.PATROL_PATROLLED,
  })

  const [deleteTopic, setDeleteTopic] = useState({
    DELETE_TOPIC_ID: null,
    DELETE_TOPIC_NAME: null,
  })

  useEffect(() => {
    const createAuthorized =
      props.auth.hasOwnProperty("role") &&
      props.auth.role.hasOwnProperty("CREATE_CATEGORY") &&
      props.auth.role.CREATE_CATEGORY
    const editAuthorized =
      props.auth.hasOwnProperty("role") &&
      props.auth.role.hasOwnProperty("EDIT_CATEGORY") &&
      props.auth.role.EDIT_CATEGORY
    const deleteAuthorized =
      props.auth.hasOwnProperty("role") &&
      props.auth.role.hasOwnProperty("DELETE_CATEGORY") &&
      props.auth.role.DELETE_CATEGORY
    const patrolAuthorized =
      props.auth.hasOwnProperty("role") &&
      props.auth.role.hasOwnProperty("PATROL_TOPIC") &&
      props.auth.role.PATROL_TOPIC

    let currentCategoryName = ""
    if (props.categories.length > 0) {
      const hit = props.categories.filter((category) => {
        return category.CATEGORY_ID === currentCategoryId
      })
      if (hit.length) {
        currentCategoryName = hit[0]["CATEGORY_NAME"]
      }
    }
    setAuth(props.auth)

    setCreateAuthorized(createAuthorized)
    setEditAuthorized(editAuthorized)
    setDeleteAuthorized(deleteAuthorized)
    setPatrolAuthorized(patrolAuthorized)

    setisLoading(true)
    setCategories(props.categories)

    setCategoryName(currentCategoryName)
    setCategoryId(currentCategoryId)
    setNewTopic((prevTopic) => ({
      ...prevTopic,
      NEW_CATEGORY_ID: currentCategoryId,
    }))
    setEditTopic((prevTopic) => ({
      ...prevTopic,
      EDIT_CATEGORY_ID: currentCategoryId,
    }))

    getTopics(currentCategoryId)
  }, [currentCategoryId, props])

  /**
   * 通信してTopicsの一覧を取得し、
   * stateのitemsに全ての情報を格納します
   */
  const getTopics = (id) => {
    if (id === -1) return

    // クエリパラメータを作成
    const params = new URLSearchParams({ categories: id }).toString()

    ajax.get(
      `${Constants.URLs.GET_TOPICS}?${params}`,
      (successJson) => {
        setItems(successJson.data || [])
        setisLoading(false)
      },
      (errorJson) => {
        setItems([])
        setisLoading(false)
        setAlertItems({
          alertTitle: errorJson.response,
          alertBody: errorJson.message + errorJson.code,
          alertModalIsOpen: true,
        })
      }
    )
  }

  /**
   * トピックをソートする
   * @param  Object items 新しいソート順になったトピックの一覧
   */
  const updateSortItems = (items) => {
    setItems(items)

    let topic_order = []
    items.forEach((val) => {
      topic_order.push(Number(val.TOPIC_ID))
    })
    const postData = {
      topic_order: topic_order,
    }

    ajax.post(
      Constants.URLs.FETCH_TOPIC_ORDER,
      postData,
      (successJson) => {
        setItems(successJson.data)
      },
      (errorJson) => {
        setAlertItems({
          alertTitle: "エラー",
          alertBody: "トピックの並び替えに失敗しました",
          alertModalIsOpen: true,
        })
        return
      }
    )
  }
  // ------------------------------------------------------------------------
  // トピック新規作成
  // ------------------------------------------------------------------------
  const toggleCreateModal = () => {
    setCreateModalIsOpen(!createModalIsOpen)
  }
  /**
   * トピック新規作成用ステートの初期化
   */
  const resetCreateTopics = () => {
    setNewTopic({
      NEW_CATEGORY_ID: categoryId,
      NEW_TOPIC_AVAILABLE_FROM: moment(),
      NEW_TOPIC_AVAILABLE_TO: moment().add(1, "weeks"),
      NEW_TOPIC_TITLE: "",
      NEW_TOPIC_BODY: "",
      NEW_TOPIC_AUTHOR_NAME: "",
      NEW_MEDIAS: [],
      NEW_PATROLLED: "ACCEPTED",
    })
  }

  const onSubmitNew = () => {
    if (!createAuthorized) return

    let message = null
    switch (true) {
      case newTopic.NEW_CATEGORY_ID === null || newTopic.NEW_CATEGORY_ID === "":
        message = "カテゴリを選択してください"
        break

      case newTopic.NEW_TOPIC_AVAILABLE_FROM === null ||
        newTopic.NEW_TOPIC_AVAILABLE_FROM === "":
        // FIXME: moment()型チェック
        message = "配信期間の開始日を選択してください"
        break

      case newTopic.NEW_TOPIC_AVAILABLE_TO === null ||
        newTopic.NEW_TOPIC_AVAILABLE_TO === "":
        // FIXME: moment()型チェック
        message = "配信期間の終了日を選択してください"
        break

      case (newTopic.NEW_MEDIAS === null || newTopic.NEW_MEDIAS.length === 0) &&
        (newTopic.NEW_TOPIC_BODY === null || newTopic.NEW_TOPIC_BODY === "") &&
        !isFullScreenCategory(categories, newTopic.NEW_CATEGORY_ID):
        message = "記事の本文を入力してください"
        break

      case newTopic.NEW_TOPIC_AUTHOR_NAME === null ||
        newTopic.NEW_TOPIC_AUTHOR_NAME === "":
        message = "記事の配信元を入力してください"
        break

      case (newTopic.NEW_TOPIC_TITLE === null ||
        newTopic.NEW_TOPIC_TITLE === "") &&
        !isFullScreenCategory(categories, newTopic.NEW_CATEGORY_ID):
        message = "記事のタイトルを入力してください"
        break

      case typeof newTopic.NEW_PATROLLED === "undefined" ||
        newTopic.NEW_PATROLLED === null ||
        newTopic.NEW_PATROLLED === "":
        message = "承認状態を選択してください"
        break

      case isFullScreenCategory(categories, newTopic.NEW_CATEGORY_ID) &&
        newTopic.NEW_MEDIAS.length === 0:
        //フルスクリーンの場合の添付ファイル添付状態
        message = "添付ファイルが添付されていません"
        break

      case typeof newTopic.NEW_MEDIAS !== "undefined" &&
        newTopic.NEW_MEDIAS.length > 0:
        newTopic.NEW_MEDIAS.forEach((media) => {
          if (
            typeof media.DISPLAY_SIZE === "undefined" ||
            ["LARGE", "MEDIUM", "SMALL"].indexOf(media.DISPLAY_SIZE) === -1
          ) {
            message = "メディアの表示サイズが指定されていません"
            return
          }
        })
        break

      default:
    }

    if (message !== null) {
      setAlertItems({
        alertTitle: "入力チェックエラー",
        alertBody: message,
        alertModalIsOpen: true,
      })
      return
    }

    postCreateTopic()
  }
  /**
   * 通信してTopicsを追加
   */
  const postCreateTopic = () => {
    if (!createAuthorized) return

    const postData = {
      category_id: newTopic.NEW_CATEGORY_ID,
      topic_title: newTopic.NEW_TOPIC_TITLE,
      topic_body: newTopic.NEW_TOPIC_BODY,
      topic_author_name: newTopic.NEW_TOPIC_AUTHOR_NAME,
      topic_available_from: newTopic.NEW_TOPIC_AVAILABLE_FROM.format("X"),
      topic_available_to: newTopic.NEW_TOPIC_AVAILABLE_TO.format("X"),
      patrolled: newTopic.NEW_PATROLLED,
      // medias内のkeyを小文字に変換
      medias: newTopic.NEW_MEDIAS.map((obj) =>
        Object.fromEntries(
          Object.entries(obj).map(([key, value]) => [key.toLowerCase(), value])
        )
      ),
    }

    console.log("create topic", postData)

    setLoadModalIsOpen(true)
    ajax.post(
      Constants.URLs.CREATE_TOPIC,
      postData,
      (successJson) => {
        setLoadModalIsOpen(false)
        setCreateModalIsOpen(false)
        resetCreateTopics()

        getTopics(categoryId)
      },
      (errorJson) => {
        setAlertItems({
          alertTitle: errorJson.response,
          alertBody: errorJson.message + errorJson.code,
          alertModalIsOpen: true,
        })
        setLoadModalIsOpen(false)
      }
    )
  }
  // ------------------------------------------------------------------------
  // トピック編集
  // ------------------------------------------------------------------------

  // 編集モーダルの状態遷移
  const toggleEditModal = () => {
    setEditModalIsOpen(!editModalIsOpen)
  }
  /**
   * 編集モーダルを表示する
   * @param  object item 編集するトピック
   */
  const showEditTopicModal = (item) => {
    setEditTopic({
      EDIT_TOPIC_ID: item.TOPIC_ID,
      EDIT_CATEGORY_ID: item.CATEGORY_ID,
      EDIT_TOPIC_AVAILABLE_FROM: moment(item.TOPIC_AVAILABLE_FROM),
      EDIT_TOPIC_AVAILABLE_TO: moment(item.TOPIC_AVAILABLE_TO),
      EDIT_TOPIC_TITLE: item.TOPIC_TITLE,
      EDIT_TOPIC_BODY: item.TOPIC_BODY,
      EDIT_TOPIC_CREATED: moment(item.TOPIC_CREATED),
      EDIT_TOPIC_AUTHOR_NAME: item.TOPIC_AUTHOR_NAME,
      EDIT_MEDIAS: item.MEDIAS,
      EDIT_TOPIC_SORT_NO: item.TOPIC_SORT_NO,
      EDIT_PATROLLED: item.PATROLLED,
    })
    setEditModalIsOpen(true)
  }

  const onSubmitEdit = () => {
    if (!editAuthorized) return

    let message = null
    switch (true) {
      case editTopic.EDIT_CATEGORY_ID === null ||
        editTopic.EDIT_CATEGORY_ID === "":
        message = "カテゴリを選択してください"
        break

      case editTopic.EDIT_TOPIC_AVAILABLE_FROM === null ||
        editTopic.EDIT_TOPIC_AVAILABLE_FROM === "":
        // FIXME: moment()型チェック
        message = "配信期間の開始日を選択してください"
        break

      case editTopic.EDIT_TOPIC_AVAILABLE_TO === null ||
        editTopic.EDIT_TOPIC_AVAILABLE_TO === "":
        // FIXME: moment()型チェック
        message = "配信期間の終了日を選択してください"
        break

      case (editTopic.EDIT_MEDIAS === null ||
        editTopic.EDIT_MEDIAS.length === 0) &&
        (editTopic.EDIT_TOPIC_BODY === null ||
          editTopic.EDIT_TOPIC_BODY === "") &&
        !isFullScreenCategory(categories, editTopic.EDIT_CATEGORY_ID):
        message = "記事の本文を入力してください"
        break

      case editTopic.EDIT_TOPIC_AUTHOR_NAME === null ||
        editTopic.EDIT_TOPIC_AUTHOR_NAME === "":
        message = "記事の配信元を入力してください"
        break

      case (editTopic.EDIT_TOPIC_TITLE === null ||
        editTopic.EDIT_TOPIC_TITLE === "") &&
        !isFullScreenCategory(categories, editTopic.EDIT_CATEGORY_ID):
        message = "記事のタイトルを入力してください"
        break

      case typeof editTopic.EDIT_PATROLLED === "undefined" ||
        editTopic.EDIT_PATROLLED === null ||
        editTopic.EDIT_PATROLLED === "":
        message = "承認状態を選択してください"
        break

      case isFullScreenCategory(categories, editTopic.EDIT_CATEGORY_ID) &&
        editTopic.EDIT_MEDIAS.length === 0:
        //フルスクリーンの場合の添付ファイル添付状態
        message = "添付ファイルが添付されていません"
        break

      case typeof editTopic.EDIT_MEDIAS !== "undefined" &&
        editTopic.EDIT_MEDIAS.length > 0:
        newTopic.NEW_MEDIAS.forEach((media) => {
          if (
            typeof media.DISPLAY_SIZE === "undefined" ||
            ["LARGE", "MEDIUM", "SMALL"].indexOf(media.DISPLAY_SIZE) === -1
          ) {
            message = "メディアの表示サイズが指定されていません"
            return
          }
        })
        break

      default:
    }

    if (message !== null) {
      setAlertItems({
        alertTitle: "入力チェックエラー",
        alertBody: message,
        alertModalIsOpen: true,
      })
      return
    }

    postEditTopic()
  }

  /**
   * 編集の送信
   */
  const postEditTopic = () => {
    if (!editAuthorized) return

    const postData = {
      topic_id: editTopic.EDIT_TOPIC_ID,
      category_id: editTopic.EDIT_CATEGORY_ID,
      topic_title: editTopic.EDIT_TOPIC_TITLE,
      topic_body: editTopic.EDIT_TOPIC_BODY,
      topic_author_name: editTopic.EDIT_TOPIC_AUTHOR_NAME,
      topic_available_from: editTopic.EDIT_TOPIC_AVAILABLE_FROM.format("X"),
      topic_available_to: editTopic.EDIT_TOPIC_AVAILABLE_TO.format("X"),
      patrolled: editTopic.EDIT_PATROLLED,
      medias: editTopic.EDIT_MEDIAS.map((obj) =>
        Object.fromEntries(
          Object.entries(obj).map(([key, value]) => [key.toLowerCase(), value])
        )
      ),
    }
    console.log("edit topic", postData)

    setLoadModalIsOpen(true)
    ajax.post(
      Constants.URLs.EDIT_TOPIC,
      postData,
      (successJson) => {
        setLoadModalIsOpen(false)
        setEditModalIsOpen(false)
        getTopics(categoryId)
      },
      (errorJson) => {
        setAlertItems({
          alertTitle: errorJson.response,
          alertBody: errorJson.message + errorJson.code,
          alertModalIsOpen: true,
        })
        setLoadModalIsOpen(false)
      }
    )
  }
  // ------------------------------------------------------------------------
  // トピック承認
  // ------------------------------------------------------------------------

  /**
   * 承認モーダルを表示する
   * @param  object item 編集するトピック
   */
  const showPatrolTopicModal = (item) => {
    setPatrolTopic({
      PATROL_TOPIC_ID: item.TOPIC_ID,
      PATROL_CATEGORY_ID: item.CATEGORY_ID,
      PATROL_TOPIC_AVAILABLE_FROM: moment(item.TOPIC_AVAILABLE_FROM),
      PATROL_TOPIC_AVAILABLE_TO: moment(item.TOPIC_AVAILABLE_TO),
      PATROL_TOPIC_TITLE: item.TOPIC_TITLE,
      PATROL_TOPIC_BODY: item.TOPIC_BODY,
      PATROL_TOPIC_CREATED: moment(item.TOPIC_CREATED),
      PATROL_TOPIC_AUTHOR_NAME: item.TOPIC_AUTHOR_NAME,
      PATROL_MEDIAS: item.MEDIAS,
      PATROL_TOPIC_SORT_NO: item.TOPIC_SORT_NO,
      PATROL_PATROLLED: item.PATROLLED,
    })
    setPatrolModalIsOpen(true)
  }

  const onSubmitPatrol = () => {
    if (!patrolAuthorized) return

    let message = null
    switch (true) {
      case typeof patrolTopic.PATROL_PATROLLED === "undefined" ||
        patrolTopic.PATROL_PATROLLED === null ||
        patrolTopic.PATROL_PATROLLED === "":
        message = "承認状態を選択してください"
        break
      default:
    }

    if (message !== null) {
      setAlertItems({
        alertTitle: "入力チェックエラー",
        alertBody: message,
        alertModalIsOpen: true,
      })
      return
    }

    postPatrolTopic()
  }
  /**
   * 承認の送信
   */
  const postPatrolTopic = () => {
    if (!patrolAuthorized) return

    const postData = {
      topic_id: patrolTopic.PATROL_TOPIC_ID,
      patrolled: patrolTopic.PATROL_PATROLLED,
    }
    console.log("patrol topic", postData)

    setLoadModalIsOpen(true)
    ajax.post(
      Constants.URLs.PATROL_TOPIC,
      postData,
      (successJson) => {
        setLoadModalIsOpen(false)
        setPatrolModalIsOpen(false)
        getTopics(categoryId)
      },
      (errorJson) => {
        setAlertItems({
          alertTitle: errorJson.response,
          alertBody: errorJson.message + errorJson.code,
          alertModalIsOpen: true,
        })
        setLoadModalIsOpen(false)
      }
    )
  }
  // ------------------------------------------------------------------------
  // トピック削除
  // ------------------------------------------------------------------------

  /**
   * 削除モーダルを表示する
   * @param  object item 削除するトピック
   */
  const showDeleteTopicModal = (item) => {
    if (!deleteAuthorized) return

    setDeleteTopic({
      DELETE_TOPIC_ID: item.TOPIC_ID,
      DELETE_TOPIC_NAME: item.TOPIC_TITLE,
    })
    setDeleteModalIsOpen(true)
  }
  /**
   * 削除の送信
   */
  const postDeleteTopic = () => {
    if (!deleteAuthorized) return

    setLoadModalIsOpen(true)
    const postData = {
      topic_id: deleteTopic.DELETE_TOPIC_ID,
    }
    console.log("delete topic", postData)

    ajax.post(
      Constants.URLs.DELETE_TOPIC,
      postData,
      (successJson) => {
        console.log(successJson)
        setLoadModalIsOpen(false)
        setDeleteModalIsOpen(false)
        getTopics(categoryId)
      },
      (errorJson) => {
        setAlertItems({
          alertTitle: errorJson.response,
          alertBody: errorJson.message + errorJson.code,
          alertModalIsOpen: true,
        })
        setLoadModalIsOpen(false)
      }
    )
  }
  const onChangeNewTitle = (val) => {
    if (!createAuthorized) return
    setNewTopic((prevTopic) => ({ ...prevTopic, NEW_TOPIC_TITLE: val }))
  }

  const onChangeNewAuthor = (val) => {
    if (!createAuthorized) return
    setNewTopic((prevTopic) => ({ ...prevTopic, NEW_TOPIC_AUTHOR_NAME: val }))
  }

  const onChangeNewBody = (val) => {
    if (!createAuthorized) return
    setNewTopic((prevTopic) => ({ ...prevTopic, NEW_TOPIC_BODY: val }))
  }

  const onChangeNewFrom = (val) => {
    if (!createAuthorized) return
    setNewTopic((prevTopic) => ({
      ...prevTopic,
      NEW_TOPIC_AVAILABLE_FROM: val,
    }))
  }

  const onChangeNewTo = (val) => {
    if (!createAuthorized) return
    setNewTopic((prevTopic) => ({ ...prevTopic, NEW_TOPIC_AVAILABLE_TO: val }))
  }

  const onChangeNewCategory = (val) => {
    if (!createAuthorized) return
    setNewTopic((prevTopic) => ({
      ...prevTopic,
      NEW_CATEGORY_ID: parseInt(val, 10),
    }))
  }

  const onChangeNewPatrolled = (val) => {
    if (!createAuthorized) return
    setNewTopic((prevTopic) => ({ ...prevTopic, NEW_PATROLLED: val }))
  }

  const onChangeNewMedias = (val) => {
    if (!createAuthorized) return
    setNewTopic((prevTopic) => ({ ...prevTopic, NEW_MEDIAS: val }))
  }

  const onChangeEditTitle = (val) => {
    if (!editAuthorized) return
    setEditTopic((prevTopic) => ({ ...prevTopic, EDIT_TOPIC_TITLE: val }))
  }

  const onChangeEditAuthor = (val) => {
    if (!editAuthorized) return
    setEditTopic((prevTopic) => ({ ...prevTopic, EDIT_TOPIC_AUTHOR_NAME: val }))
  }

  const onChangeEditBody = (val) => {
    if (!editAuthorized) return
    setEditTopic((prevTopic) => ({ ...prevTopic, EDIT_TOPIC_BODY: val }))
  }

  const onChangeEditFrom = (val) => {
    if (!editAuthorized) return
    setEditTopic((prevTopic) => ({
      ...prevTopic,
      EDIT_TOPIC_AVAILABLE_FROM: val,
    }))
  }

  const onChangeEditTo = (val) => {
    if (!editAuthorized) return
    setEditTopic((prevTopic) => ({
      ...prevTopic,
      EDIT_TOPIC_AVAILABLE_TO: val,
    }))
  }

  const onChangeEditCategory = (val) => {
    if (!editAuthorized) return
    setEditTopic((prevTopic) => ({
      ...prevTopic,
      EDIT_CATEGORY_ID: parseInt(val, 10),
    }))
  }

  const onChangeEditPatrolled = (val) => {
    if (!editAuthorized) return
    setEditTopic((prevTopic) => ({ ...prevTopic, EDIT_PATROLLED: val }))
  }

  const onChangeEditMedias = (val) => {
    if (!editAuthorized) return
    setEditTopic((prevTopic) => ({ ...prevTopic, EDIT_MEDIAS: val }))
  }

  const onChangePatrolPatrolled = (val) => {
    if (!editAuthorized && !patrolAuthorized) return
    setPatrolTopic((prevTopic) => ({ ...prevTopic, PATROL_PATROLLED: val }))
  }
  const currentCategory = categories.filter((category) => {
    return category.CATEGORY_ID === categoryId
  })[0]

  const closeLoadModal = () => {
    setLoadModalIsOpen(false)
  }

  const closeDeleteModal = () => {
    setDeleteModalIsOpen(false)
  }

  const closeAlertModal = () => {
    setAlertItems((prevTopic) => ({ ...prevTopic, alertModalIsOpen: false }))
  }

  //const isUserContributionsCategory = currentCategory.IS_SPECIAL && currentCategory.CATEGORY_NAME === 'ユーザー投稿';
  const isUserContributionsCategory = currentCategory?.IS_SPECIAL

  console.log("items", items)

  return (
    <div id="Category">
      <ContentHeader
        title={categoryName}
        breadCrumbItems={[
          {
            title: `トピック追加・編集(${categoryName})`,
            icon: "notification",
            path: "",
          },
        ]}
      />
      {isLoading ? (
        <Box sx={{ display: "flex" }}>
          <CircularProgress />
        </Box>
      ) : (
        <div>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginBottom: "20px",
            }}
          >
            <Button
              variant="contained"
              startIcon={<CreateIcon />}
              color={"primary"}
              disableElevation
              onClick={() => {
                toggleCreateModal()
              }}
            >
              新規トピックの追加
            </Button>
          </div>

          <TopicsRow
            auth={auth}
            items={items}
            showPatrol={isUserContributionsCategory}
            editTopics={(item) => {
              showEditTopicModal(item)
            }}
            updateSortItems={(items) => {
              updateSortItems(items)
            }}
            deleteTopic={(item) => {
              showDeleteTopicModal(item)
            }}
            patrolTopic={(item) => {
              showPatrolTopicModal(item)
            }}
          />
          <TopicForm
            auth={auth}
            isNew={true}
            isOpen={createModalIsOpen}
            categories={categories}
            onSubmit={() => {
              onSubmitNew()
            }}
            toggleModal={() => {
              toggleCreateModal()
            }}
            onChangeTitle={(val) => {
              onChangeNewTitle(val)
            }}
            onChangeAuthor={(val) => {
              onChangeNewAuthor(val)
            }}
            onChangeBody={(val) => {
              onChangeNewBody(val)
            }}
            onChangeFrom={(val) => {
              onChangeNewFrom(val)
            }}
            onChangeTo={(val) => {
              onChangeNewTo(val)
            }}
            onChangeCategory={(val) => {
              onChangeNewCategory(val)
            }}
            onChangePatrolled={(val) => {
              onChangeNewPatrolled(val)
            }}
            onChangeMedias={(val) => {
              onChangeNewMedias(val)
            }}
            onReset={() => {
              resetCreateTopics()
            }}
            CATEGORY_ID={newTopic.NEW_CATEGORY_ID}
            TOPIC_TITLE={newTopic.NEW_TOPIC_TITLE}
            TOPIC_BODY={newTopic.NEW_TOPIC_BODY}
            TOPIC_AUTHOR_NAME={newTopic.NEW_TOPIC_AUTHOR_NAME}
            TOPIC_AVAILABLE_FROM={newTopic.NEW_TOPIC_AVAILABLE_FROM}
            TOPIC_AVAILABLE_TO={newTopic.NEW_TOPIC_AVAILABLE_TO}
            MEDIAS={newTopic.NEW_MEDIAS}
            PATROLLED={newTopic.NEW_PATROLLED}
            TOPIC_CREATED={null}
          />
          <TopicForm
            auth={auth}
            isNew={false}
            isOpen={editModalIsOpen}
            categories={categories}
            onSubmit={() => {
              onSubmitEdit()
            }}
            toggleModal={() => {
              toggleEditModal()
            }}
            onChangeTitle={(val) => {
              onChangeEditTitle(val)
            }}
            onChangeAuthor={(val) => {
              onChangeEditAuthor(val)
            }}
            onChangeBody={(val) => {
              onChangeEditBody(val)
            }}
            onChangeFrom={(val) => {
              onChangeEditFrom(val)
            }}
            onChangeTo={(val) => {
              onChangeEditTo(val)
            }}
            onChangeCategory={(val) => {
              onChangeEditCategory(val)
            }}
            onChangePatrolled={(val) => {
              onChangeEditPatrolled(val)
            }}
            onChangeMedias={(val) => {
              onChangeEditMedias(val)
            }}
            TOPIC_ID={editTopic.EDIT_TOPIC_ID}
            CATEGORY_ID={editTopic.EDIT_CATEGORY_ID}
            TOPIC_TITLE={editTopic.EDIT_TOPIC_TITLE}
            TOPIC_BODY={editTopic.EDIT_TOPIC_BODY}
            TOPIC_AUTHOR_NAME={editTopic.EDIT_TOPIC_AUTHOR_NAME}
            TOPIC_AVAILABLE_FROM={editTopic.EDIT_TOPIC_AVAILABLE_FROM}
            TOPIC_AVAILABLE_TO={editTopic.EDIT_TOPIC_AVAILABLE_TO}
            MEDIAS={editTopic.EDIT_MEDIAS}
            PATROLLED={editTopic.EDIT_PATROLLED}
            TOPIC_CREATED={editTopic.EDIT_TOPIC_CREATED}
          />
          <TopicForm
            auth={auth}
            isNew={false}
            isOpen={patrolModalIsOpen}
            categories={categories}
            onSubmit={() => {
              onSubmitPatrol()
            }}
            toggleModal={() => {
              togglePatrolModal()
            }}
            onChangePatrolled={(val) => {
              onChangePatrolPatrolled(val)
            }}
            TOPIC_ID={patrolTopic.PATROL_TOPIC_ID}
            CATEGORY_ID={patrolTopic.PATROL_CATEGORY_ID}
            TOPIC_TITLE={patrolTopic.PATROL_TOPIC_TITLE}
            TOPIC_BODY={patrolTopic.PATROL_TOPIC_BODY}
            TOPIC_AUTHOR_NAME={patrolTopic.PATROL_TOPIC_AUTHOR_NAME}
            TOPIC_AVAILABLE_FROM={patrolTopic.PATROL_TOPIC_AVAILABLE_FROM}
            TOPIC_AVAILABLE_TO={patrolTopic.PATROL_TOPIC_AVAILABLE_TO}
            MEDIAS={patrolTopic.PATROL_MEDIAS}
            PATROLLED={patrolTopic.PATROL_PATROLLED}
            TOPIC_CREATED={patrolTopic.PATROL_TOPIC_CREATED}
          />

          <Dialog
            open={alertItems.alertModalIsOpen}
            onClose={closeAlertModal}
            maxWidth="sm"
            fullWidth
          >
            <DialogTitle>{alertItems.alertTitle}</DialogTitle>
            <DialogContent>{alertItems.alertBody}</DialogContent>
            <DialogActions>
              <Button onClick={closeAlertModal} color="primary">
                Close
              </Button>
            </DialogActions>
          </Dialog>

          <Dialog
            open={deleteModalIsOpen}
            onClose={closeDeleteModal}
            maxWidth="md"
            fullWidth
          >
            <DialogTitle>トピックを削除します</DialogTitle>
            <DialogContent>
              <div>
                トピック「{deleteTopic.DELETE_TOPIC_NAME}
                」を削除します。よろしいですか？
              </div>
            </DialogContent>
            <DialogActions>
              <Button
                style={{ width: "150px" }}
                onClick={postDeleteTopic}
                color="primary"
              >
                削除
              </Button>
              <Button
                style={{ width: "150px" }}
                onClick={closeDeleteModal}
                color="primary"
              >
                キャンセル
              </Button>
            </DialogActions>
          </Dialog>

          <Dialog open={loadModalIsOpen} onClose={closeLoadModal}>
            <DialogContent>
              <CircularProgress size={40} thickness={4} />
            </DialogContent>
          </Dialog>
        </div>
      )}
    </div>
  )
}

Topics.defaultProps = {
  CATEGORY_ID: -1,
  CATEGORY_NAME: "",

  NEW_TOPIC_AVAILABLE_FROM: moment(),
  NEW_TOPIC_AVAILABLE_TO: moment().add(1, "weeks"),
  EDIT_TOPIC_AVAILABLE_FROM: moment(),
  EDIT_TOPIC_AVAILABLE_TO: moment().add(1, "weeks"),
}

export default Topics
